import * as React from "react";

import { cn } from "../../lib/utils";

// Inline validation message for a form field. Renders nothing when empty, so it
// can be left mounted next to a control. Pair with Input/Textarea `error`.
export type FieldErrorProps = React.HTMLAttributes<HTMLParagraphElement>;

const FieldError = React.forwardRef<HTMLParagraphElement, FieldErrorProps>(
  ({ className, children, ...props }, ref) => {
    if (!children) return null;
    return (
      <p
        ref={ref}
        role="alert"
        className={cn("mt-1 text-xs font-medium text-red-600 dark:text-red-400", className)}
        {...props}
      >
        {children}
      </p>
    );
  },
);
FieldError.displayName = "FieldError";

export { FieldError };
